import { ForbiddenExpenseItem } from "~/application/types/entities/ForbiddenExpenseItem.type";
import { ForbiddenExpenseItemDTO } from "../dtos/ForbiddenExpenseItemDTO";

export function mapForbiddenExpenseItemDTO(data: ForbiddenExpenseItemDTO): ForbiddenExpenseItem {
  return {
    uuid: data.uuid,
    name: data.name,
    items: data.items,
  };
}
